export default new (class Menu {
    constructor() {
        this.menu = 'menu';
        this.menuContent = 'menu-content';
        this.menuBtn = 'menu-item';
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelectorAll(`.${this.menuBtn}`).forEach((item) => {
                item.addEventListener('click', (e) => {
                    if(e.target.tagName.toLowerCase() !== 'a') {
                        e.preventDefault();

                        if(item.closest(`.${this.menu}`).querySelector(`.${this.menuContent}`)) {
                            document.querySelectorAll(`.${this.menu}`).forEach((menu) => {
                                if(menu != item.closest(`.${this.menu}`)) {
                                    menu.classList.remove('open')
                                    if( menu.querySelector(`.${this.menuContent}`)) {
                                        menu.querySelector(`.${this.menuContent}`).removeAttribute('style')
                                    }
                                }
                            });
                            item.closest(`.${this.menu}`).classList.toggle('open')

                            if(item.closest(`.${this.menu}`).classList.contains('open')) {
                                item.closest(`.${this.menu}`).querySelector(`.${this.menuContent}`).style.maxHeight = item.closest(`.${this.menu}`).querySelector(`.${this.menuContent}`).scrollHeight + 'px';
                            }
                            else {
                                item.closest(`.${this.menu}`).querySelector(`.${this.menuContent}`).removeAttribute('style')
                            }
                        }
                    }
                });
            });
        });
    }
})()
